import { logger } from "common/utilities/logger";

export const safelyToUrl = (value: string) => {
  try {
    return new URL(value);
  } catch (error) {
    logger.error(`[safelyToUrl] Failed to construct URL from ${value}`, error);
    return undefined;
  }
};
